import { GA_APP, GA_USER_TYPE } from '@src/lib/google-analytics';
import ReactGA from 'react-ga4';

export const COMMON_APPLICATION_ACTION = 'Common Application V2';
export const COMMON_REGISTRATION_ACTION = 'Common Registration V2';

export type CommonApplicationEventName =
  'Start' | 'Continue' | 'Next Step' | 'Cancel' | 'Submit' | 'Dismiss Reminder';

export type CommonApplicationAction =
  typeof COMMON_APPLICATION_ACTION | typeof COMMON_REGISTRATION_ACTION;

type CommonApplicationEvent = {
  name: CommonApplicationEventName;
  /** Defaults to the event name, as most events use it. */
  label?: string;
  /** Defaults to Common Application V2. */
  action?: CommonApplicationAction;
};

/**
 * Send a V2 common application event to Google Analytics, in the shape the
 * Rails app's events use. Business status isn't an event value: it's the
 * businessUser user property, as in Rails. The gtag snippet in index.html
 * loads GA, so react-ga4 needs no initialize() to pass events through to it.
 *
 * Send no personal data here: names, contact details, and IDs stay out of GA.
 */
export function trackCommonApplicationEvent({
  name,
  label = name,
  action = COMMON_APPLICATION_ACTION,
}: CommonApplicationEvent): void {
  if (!import.meta.env.VITE_GOOGLE_ANALYTICS_PROPERTY_ID) {
    return;
  }
  try {
    ReactGA.event(name, {
      category: 'Common Application',
      action,
      label,
      userType: GA_USER_TYPE,
      app: GA_APP,
    });
  } catch {
    // Analytics must never get in the way of the application.
  }
}
